import userRules from '@/constaints/rules/userRules/';

var rules = {
    userRules:userRules,
}

export default rules;